module.exports = __webpack_public_path__ + "img/vtho.4423d896.svg";